import { gql } from "@apollo/client";

export const POST_USER_WAYPOINT = gql`
  mutation PostUserWaypoint($BuildingId: uuid, $Lat: float8, $Lng: float8) {
    insert_Task(
      objects: {
        BuildingId: $BuildingId
        Name: "Please go to point"
        Priority: 3
        isActive: false
        SubTasks: {
          data: {
            Description: "Please go to the point shown"
            OrderNumber: 1
            SubTaskType: "Waypoint"
            Waypoints: { data: { Lat: $Lat, Long: $Lng } }
          }
        }
      }
    ) {
      returning {
        Id
        Priority
        Name
        isActive
        SubTasks {
          Id
          Description
          SubTaskType
          OrderNumber
          Waypoints {
            Lat
            Long
            Id
          }
        }
      }
    }
  }
`;

export const GET_TASKS = gql`
  query GetTasks($limit: Int = 10, $offset: Int = 10, $buildingId: uuid) {
    Task(
      limit: $limit
      offset: $offset
      order_by: { updated_at: asc }
      where: {
        isActive: { _eq: true }
        _and: { BuildingId: { _eq: $buildingId } }
      }
    ) {
      BuildingId
      Description
      Id
      IdealCompletionTime
      Name
      Priority
      isActive
      created_at
      updated_at
      SubTasks(order_by: { OrderNumber: asc }) {
        Id
        Description
        SubTaskType
      }
    }
    Task_aggregate(where: { isActive: { _eq: true } }) {
      aggregate {
        count
      }
    }
  }
`;

// export const POST_TASK = gql`
//   mutation InsertTask($BuildingId: uuid, $Name: String, $Priority: Int = 3) {
//     insert_Task(
//       objects: {
//         BuildingId: $BuildingId
//         Name: $Name
//         Priority: $Priority
//         isActive: true
//       }
//       on_conflict: {
//         constraint: Task_pkey
//         update_columns: [Name, Priority, isActive]
//       }
//     ) {
//       returning {
//         Id
//       }
//     }
//   }
// `;
export const POST_SUB_TASKS = gql`
  mutation InsertSubTasks($subTasks: [SubTask_insert_input!]!) {
    insert_SubTask(
      objects: $subTasks
      on_conflict: {
        constraint: SubTask_Id_key
        update_columns: [Description, OrderNumber, IsRepeatable, active]
      }
    ) {
      returning {
        Id
      }
    }
  }
`;

export const POST_TASK_ITEMS = gql`
  mutation InsertTaskItems(
    $OrderNumber: Int = 10
    $SubTaskId: bigint = ""
    $TaskItemType: String = ""
    $BarcodeTaskItems: BarcodeTaskItem_arr_rel_insert_input = { data: {} }
    $Checklists: Checklist_arr_rel_insert_input = { data: {} }
    $SignatureTaskItems: SignatureTaskItem_arr_rel_insert_input = { data: {} }
    $TakePhotoTaskItems: TakePhotoTaskItem_arr_rel_insert_input = { data: {} }
    $FormItems: FormItem_arr_rel_insert_input = { data: {} }
  ) {
    insert_TaskItem(
      objects: {
        OrderNumber: $OrderNumber
        SubTaskId: $SubTaskId
        TaskItemType: $TaskItemType
        BarcodeTaskItems: $BarcodeTaskItems
        Checklists: $Checklists
        SignatureTaskItems: $SignatureTaskItems
        TakePhotoTaskItems: $TakePhotoTaskItems
        FormItems: $FormItems
      }
    ) {
      affected_rows
    }
  }
`;
// export const POST_SCHEDULES = gql``;

export const INSERT_TASK = gql`
  mutation InsertTask(
    $BuildingId: uuid = ""
    $Name: String = ""
    $Priority: Int = 10
    $SubTasks: SubTask_arr_rel_insert_input = { data: {} }
    $Schedules: Schedules_arr_rel_insert_input = { data: {} }
    $OnceOffSchedules: OnceOffSchedule_arr_rel_insert_input = { data: {} }
  ) {
    insert_Task(
      objects: {
        BuildingId: $BuildingId
        Name: $Name
        isActive: true
        Priority: $Priority
        SubTasks: $SubTasks
        Schedules: $Schedules
        OnceOffSchedules: $OnceOffSchedules
      }
    ) {
      returning {
        BuildingId
        Name
        Priority
        Schedules {
          Id
          Active
          ScheduleBlob
          cronExpression
          days
          time
        }
        OnceOffSchedules {
          Date
          Id
          Time
          isActive
          cronExpression
        }
        Id
      }
    }
  }
`;

export const GET_TASK_INSTANCES = gql`
  query GetTaskInstances(
    $buildingId: uuid = ""
    $limit: Int = 10
    $offset: Int = 10
  ) {
    TaskInstance(
      where: {
        Shift_Gaurd: { Shift: { Building: { Id: { _eq: $buildingId } } } }
      }
      order_by: { StartDateTime: desc }
      limit: $limit
      offset: $offset
    ) {
      completed
      StartDateTime
      EndDateTime
      Task {
        Description
        Name
      }
      Shift_Gaurd {
        Gaurd {
          GaurdFirstName
        }
      }
      paused
      Id
    }
    TaskInstance_aggregate(
      where: {
        Shift_Gaurd: { Shift: { Building: { Id: { _eq: $buildingId } } } }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const INSERT_NEXT_RUN = gql`
  mutation InsertNextRunTime(
    $cronSchedule: String
    $nextRunTime: timestamptz
    $priority: Int
    $roleId: String
    $scheduleId: bigint
    $taskId: bigint
    $taskName: String
    $buildingId: uuid
    $onceOff: Boolean = false
  ) {
    insert_NextRunTime(
      objects: {
        active: true
        cronSchedule: $cronSchedule
        nextRunTime: $nextRunTime
        priority: $priority
        roleId: $roleId
        scheduleId: $scheduleId
        taskId: $taskId
        taskName: $taskName
        buildingId: $buildingId
        onceOff: $onceOff
      }
    ) {
      affected_rows
    }
  }
`;
